import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c43a03e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contaienr" }
const _hoisted_3 = { class: "invoice" }
const _hoisted_4 = { class: "price" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slogan" }, "请尽快完成支付以免订单支付超时", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "支付完成后我们会尽快为您安排出库", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "如果疑问请及时联系客服", -1))
const _hoisted_8 = { class: "payment-content" }
const _hoisted_9 = { class: "g-card" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择支付方式", -1))
const _hoisted_11 = { class: "payment" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "label" }
const _hoisted_15 = ["value", "checked", "disabled"]
const _hoisted_16 = { class: "footer-ctrl" }
const _hoisted_17 = { class: "el-overlay-dialog" }
const _hoisted_18 = {
  class: "el-dialog",
  "aria-modal": "true",
  role: "dialog",
  "aria-label": "扫码支付",
  style: {"--el-dialog-width":"340px"}
}
const _hoisted_19 = { class: "el-dialog__header" }
const _hoisted_20 = { class: "el-dialog__title" }
const _hoisted_21 = { class: "desc" }
const _hoisted_22 = { class: "el-dialog__body" }
const _hoisted_23 = { class: "qrcode" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "¥ " + _toDisplayString(_ctx.orderAmount), 1),
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                onChange: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changePayment && _ctx.changePayment(...args)), ["stop"]))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment, (item, idx) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "g-radio form-item-checkbox",
                    key: idx
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: item.icon,
                        class: "icon"
                      }, null, 8, _hoisted_13),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.title) + _toDisplayString(item.note), 1)
                    ]),
                    _createElementVNode("input", {
                      type: "radio",
                      value: item.id,
                      checked: _ctx.selectPayment == item.id,
                      disabled: item.disabled
                    }, null, 8, _hoisted_15)
                  ]))
                }), 128))
              ], 32)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "g-button g-button-danger",
            "hover-class": "hover",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startPay && _ctx.startPay(...args)), ["stop"]))
          }, " 立即支付 ")
        ])
      ])
    ]),
    (_ctx.paymentDialogForm.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "payment-dialog",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePaymentDialog && _ctx.closePaymentDialog(...args)))
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.paymentDialogForm.title) + "扫码支付", 1),
                _createElementVNode("span", _hoisted_21, " 使用" + _toDisplayString(_ctx.paymentDialogForm.title) + "扫一扫 ", 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.selectPayment == 'alipay')
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 0,
                        width: "264",
                        height: "264",
                        frameborder: "no",
                        border: "0",
                        marginwidth: "0",
                        marginheight: "0",
                        scrolling: "no",
                        src: _ctx.paymentDialogForm.qrcode,
                        seamless: ""
                      }, null, 8, _hoisted_24))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.paymentDialogForm.qrcode
                      }, null, 8, _hoisted_25))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}